import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const CategoryGroup = ({ groupName, icon, isSelected, onSelect }) => (
  <li
    className={twJoin(
      'flex cursor-pointer select-none items-center gap-x-2 rounded-3 py-2 transition-all',
      isSelected && 'bg-neutral-high-200 p-2 dark:bg-neutral-low-400'
    )}
    onFocus={onSelect}
    onMouseOver={onSelect}
  >
    <div className="flex items-center justify-center rounded-full bg-neutral-high-200 p-2 dark:bg-neutral-low-400">
      <Icon
        className="text-primary-300 dark:text-primary-300"
        name={icon}
        size="size3"
      />
    </div>
    <Text
      className="flex-1 text-start text-neutral-low-200 dark:text-neutral-high-300"
      size="size2"
    >
      {groupName}
    </Text>
  </li>
);

CategoryGroup.propTypes = {
  groupName: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default CategoryGroup;
